import Lighting from '../../../base/menu/airdome/Lighting';

const lighting: Lighting = {
  categoryName: 'Lighting',
  current: 'Current'
};

export default lighting;
